import { render, staticRenderFns } from "./NewsCover.vue?vue&type=template&id=bb97394c"
import script from "./NewsCover.vue?vue&type=script&lang=js"
export * from "./NewsCover.vue?vue&type=script&lang=js"
import style0 from "./NewsCover.vue?vue&type=style&index=0&id=bb97394c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports